import { zodResolver } from "@hookform/resolvers/zod";
import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { CHANGE_PASSWORD } from "../../../../../services/ApiCalls";
import { toast } from "react-toastify";

const schema = z
  .object({
    oldPassword: z
      .string()
      .trim()
      .min(1, { message: "Old Password is required" }),
    newPassword: z
      .string()
      .trim()
      .min(1, { message: "new Password is required" }),
    confirmPassword: z
      .string()
      .trim()
      .min(1, { message: "confirm Password is required" }),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    path: ["confirmPassword"],
    message: "Passwords does not match",
  });

const ChangePasswordTab = () => {
  
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
    reValidateMode: "onChange",
    mode: "onChange",
  });

  const submitHandler = async (data) => {
    try {
      const resetRes = await CHANGE_PASSWORD(data);
      if (resetRes?.data?.status === "success") {
        toast.success(resetRes?.data?.message);
      } else {
        toast.error(resetRes?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };
  return (
    <>
      <Form className="pt-lg-4" onSubmit={handleSubmit(submitHandler)}>
        <Row className="">
          <Col lg="4" sm="6" className="my-2">
            <label
              htmlFor=""
              className="form-label fw-sbold text-dark m-0 pb-1"
            >
              Enter Current Password
            </label>
            <input
              type="password"
              className="form-control"
              {...register("oldPassword")}
              
            />
            {
              <p className="errorColor">
                {errors?.oldPassword && errors.oldPassword.message}
              </p>
            }
          </Col>
          <Col lg="4" sm="6" className="my-2">
            <label
              htmlFor=""
              className="form-label fw-sbold text-dark m-0 pb-1"
            >
              Enter New Password
            </label>
            <input
              type="password"
              className="form-control"
              {...register("newPassword")}
            />
            {
              <p className="errorColor">
                {errors?.newPassword && errors.newPassword.message}
              </p>
            }
          </Col>
          <Col lg="4" sm="6" className="my-2">
            <label
              htmlFor=""
              className="form-label fw-sbold text-dark m-0 pb-1"
            >
              Enter Confirm Password
            </label>
            <input
              type="password"
              className="form-control"
              {...register("confirmPassword")}
            />
            {
              <p className="errorColor">
                {errors?.confirmPassword && errors.confirmPassword.message}
              </p>
            }
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col sm="4" className="my-2">
            <div className="btnWrpper my-3">
              <Button
                className="d-flex w-100 align-items-center justify-content-center commonBtn"
                type="submit"
              >
                Save
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default ChangePasswordTab;
